module.exports = __webpack_public_path__ + "static/media/hg-studio.748d8515.png";